const EMAIL_TEMPLATES_DOMAIN = 'emailTemplates'
const EMAIL_TEMPLATES_STATE = {
  all: {
    data: [],
    status: null
  },
  data: {},
  /**
   * Instance used to send the email template to a mailing list.
   * @type {MailingList}
   */
  mailingList: null
}

const EMAIL_TEMPLATES_PATH = {
  MAILING_LIST: `${EMAIL_TEMPLATES_DOMAIN}.mailingList`
}

const EMAIL_TEMPLATES_ENDPOINT = {
  SEND: '/emailTemplates/send'
}

export {
  EMAIL_TEMPLATES_DOMAIN,
  EMAIL_TEMPLATES_STATE,
  EMAIL_TEMPLATES_PATH,
  EMAIL_TEMPLATES_ENDPOINT
}
